import { Component, input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormInputRadioItemInterface } from './form-input-radio.interface';

@Component({
  selector: 'shared-form-input-radio',
  templateUrl: './form-input-radio.component.html',
  styleUrls: ['./form-input-radio.component.css'],
  imports: [FormsModule, ReactiveFormsModule],
})
export class FormInputRadioComponent {
  radioButtonData = input.required<FormInputRadioItemInterface>();

  control = input.required<FormControl>();
}
